var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.83366H0.5M11.3333 1.16699V4.50033M4.66667 1.16699V4.50033M4.5 17.8337H11.5C12.9001 17.8337 13.6002 17.8337 14.135 17.5612C14.6054 17.3215 14.9878 16.939 15.2275 16.4686C15.5 15.9339 15.5 15.2338 15.5 13.8337V6.83366C15.5 5.43353 15.5 4.73346 15.2275 4.19868C14.9878 3.72828 14.6054 3.34583 14.135 3.10614C13.6002 2.83366 12.9001 2.83366 11.5 2.83366H4.5C3.09987 2.83366 2.3998 2.83366 1.86502 3.10614C1.39462 3.34583 1.01217 3.72828 0.772484 4.19868C0.5 4.73346 0.5 5.43353 0.5 6.83366V13.8337C0.5 15.2338 0.5 15.9339 0.772484 16.4686C1.01217 16.939 1.39462 17.3215 1.86502 17.5612C2.3998 17.8337 3.09987 17.8337 4.5 17.8337Z",
    stroke: "#717171",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.198faa4104a65ac754b4a7a1dd3b7fcb.svg";
export { ForwardRef as ReactComponent };